import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { colors, Button } from 'react-orange-ui';

import WordingService from '../../../services/WordingService';
import {
  Container, Banner, Details, Actions, BannerDetail, BannerType,
} from './BaseBanner';

/**
 * API error banner component
 * @return {*}
 * @constructor
 */
class ErrorApi extends Component {
  handleCopy = () => {
    const { error, handleCopy } = this.props;
    handleCopy(JSON.stringify(error));
  };

  render() {
    const {
      error, handleClose, handleClick, collapse, pathname,
    } = this.props;
    const isPartnerError = error.data.code === 500004;

    return (
      <Container id="error-banner">
        <Banner id="error-banner__resume" onClick={handleClick} background={isPartnerError ? colors.supportingLighterCandy : colors.seeThroughRed}>
          <BannerType icon={isPartnerError ? 'info' : 'error-severe'} color={isPartnerError ? colors.supportingLavender : colors.functionalRed} title={isPartnerError ? 'errorPartner' : 'errorApi'} />
          <BannerDetail label="Message HTTP" content={error.statusText} />
          <BannerDetail label="Statut HTTP" content={error.status} />
          <BannerDetail label="Code d'erreur" content={error.data.code} />
          <BannerDetail label="Message" content={error.data.message} />
        </Banner>
        <Details id="error-banner__details" collapse={collapse} borderColor={isPartnerError ? colors.supportingLighterCandy : colors.seeThroughRed}>
          <div>
            <BannerDetail label="Method" content={error.config.method} />
            <BannerDetail label="API Endpoint" content={error.config.url} />
            {error.config['axios-retry']
            && (
            <div>
              <BannerDetail label="Retry count" content={error.config['axios-retry'].retryCount} />
              <BannerDetail label="Last request time" content={error.config['axios-retry'].lastRequestTime} />
            </div>
            )
            }
            <BannerDetail label="Route" content={pathname} />
          </div>
          <BannerDetail label="Raw response" content={JSON.stringify(error.data)} raw />
          <div>
            <BannerDetail label="Headers response" content={JSON.stringify(error.headers)} raw />
            <Button size="s" onClick={this.handleCopy}>
              {WordingService.getWording('button', 'copy')}
            </Button>
          </div>
        </Details>
        <Actions id="error-banner__actions">
          <Button id="close-banner-action" type="icon" size="s" icon="delete" aria-label="Fermer bandeau erreur" onClick={handleClose} />
        </Actions>
      </Container>
    );
  }
}

ErrorApi.propTypes = {
  /** Boolean banner is collapse */
  collapse: PropTypes.bool.isRequired,
  /** Object error */
  error: PropTypes.shape().isRequired,
  /** String pathname route location */
  pathname: PropTypes.string.isRequired,
  /** Function callback */
  handleClick: PropTypes.func.isRequired,
  /** Function callback */
  handleClose: PropTypes.func.isRequired,
  /** Function callback */
  handleCopy: PropTypes.func.isRequired,
};

export default ErrorApi;
